/**
 * MakeupEarlyHint — dòng nhắc ở CỬA SỚM của người trang điểm (quyết định
 * 0261): dòng tự nhận ca, đơn còn "Đã đặt", đã tới ngày chụp.
 *
 * Khối ảnh và nút "Hoàn tất makeup" dùng lại y hệt khối của ca đang chụp; chỉ
 * thêm câu này để người bấm biết cú bấm đó chính là mốc đưa đơn sang "Đang
 * chụp". Dùng chung cho thẻ ca Tổng quan và khung Phân công Ekip ở Lịch chụp
 * để hai màn nói cùng một câu.
 */
export function MakeupEarlyHint() {
  return (
    <div className="mt-1.5 text-[10px] font-semibold text-[var(--color-info-text)]">
      Nộp đủ ảnh trước và sau trang điểm rồi bấm Hoàn tất makeup là đơn tự chuyển sang Đang chụp
    </div>
  );
}
